export enum GptModelsEnum {
    Gpt5Mini = 0,
    O3Mini = 1,
    Gpt41 = 2,
    DallE = 3,
    O1 = 4,
    Gpt5 = 5,
    Auto = 6,
}

export const DEFAULT_GPT_MODEL = GptModelsEnum.Auto;
